import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { Box, Spinner, Center } from '@chakra-ui/react';

interface AdminRouteProps {
  children: ReactNode;
}

export const AdminRoute = ({ children }: AdminRouteProps) => {
  const { currentUser, isLoading } = useAuth();
  const location = useLocation();

  // Mostrar spinner mientras se verifica la autenticación
  if (isLoading) {
    return (
      <Box minH="100vh">
        <Center h="100vh">
          <Spinner size="xl" color="red.500" />
        </Center>
      </Box>
    );
  }

  // Redirigir a login si no hay usuario autenticado
  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Verificar si el usuario es administrador
  if (currentUser.role !== 'Admin') {
    return <Navigate to="/" replace />;
  }

  // Si el usuario es administrador, mostrar el contenido protegido
  return <>{children}</>;
};
